module.exports = __webpack_public_path__ + "assets/img/404.0a38972b.png";